"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedCodes = void 0;
exports.sharedCodes = {
    caseUid: "83ffb36c-997b-47a6-8253-25af87a626d7",
    isChargeable: true,
    caseType: "EPIC_EMBEDDED",
    tenantId: {
        uuid: "ABCCCEEA-6193-4575-B90D-C7E657C0B922"
    },
    healthSystemTenantId: {
        uuid: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59"
    },
    guid: {
        uuid: "3a2fd7bf-0cf4-4dff-82e9-0edbd8517a29"
    },
    serviceLine: "PATHOLOGY",
    gender: "M",
    dateOfBirth: "1980-07-26",
    age: null,
    hl7InsurancePayerId: null,
    hl7InsurancePlanId: null,
    cmxInsurancePayerId: null,
    status: "IN_PROGRESS",
    qaStatus: null,
    documentImprovements: [],
    autoCancelled: false,
    sharedDiagnosisCodes: [
        {
            diagnosis_code: "CAR.0",
            sequence_number: 1,
            evidence: [
                {
                    feature: {
                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                        type: "categorical",
                        category: "Spine",
                        field: "body_region"
                    },
                    type: "Categorical",
                    score: 0.04377880184331798
                },
                {
                    feature: {
                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c66",
                        type: "categorical",
                        category: "PET",
                        field: "procedure_category"
                    },
                    type: "Categorical",
                    score: 0.23316912972085382
                },
                {
                    feature: {
                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
                        type: "ngram",
                        ngram: "dome of the diaphragm",
                        slop: 1,
                        in_order: true,
                        field: "raw_body",
                        spans: [
                            {
                                start: 0,
                                end: 49,
                                content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                                level: "ngram"
                            },
                            {
                                start: 0,
                                end: 49,
                                content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                                level: "sentence"
                            }
                        ]
                    },
                    type: "Ngram",
                    score: 1.8524357683146013
                },
                {
                    feature: {
                        uuid: "blah",
                        type: "ngram",
                        ngram: "dome of the diaphragm",
                        slop: 1,
                        in_order: true,
                        field: "raw_reasonforvisit",
                        spans: []
                    },
                    type: "Ngram",
                    score: 1.8524357683146013
                }
            ],
            additionalProperties: {
                id: 103
            },
            shared: true,
            active: true
        },
        {
            diagnosis_code: "R91.8",
            sequence_number: 2,
            evidence: [],
            additionalProperties: {
                id: 105
            },
            shared: true,
            active: true
        },
        {
            diagnosis_code: "LIN.5",
            sequence_number: 3,
            evidence: [],
            additionalProperties: {
                id: 108
            },
            shared: true,
            active: true
        }
    ],
    invoices: [
        {
            type: "assembled",
            guid: "4421eab9-3e03-4523-a379-54cedc593a5f",
            date_of_service: "2023-01-24",
            datetime_of_service: "2023-01-24 00:00:00 EST",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            errorMessages: [],
            billing_area: null,
            division: null,
            facility: null,
            filler_number: {
                number: "PATH_CMX_AUT_013_match_charges_and_roll_up_units_passthrough-2023-2f27f00e022d4eb7931debcc990f5b48",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: null,
            billing_provider_number: {
                number: "1521674",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: "1000154",
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: "1521674",
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [
                {
                    guid: "f5ac9dc1-c026-4523-86c4-41090feef971",
                    sequence_number: 1,
                    source_transaction_id: "3",
                    deleted: false,
                    errorMessages: [],
                    technical_code: {
                        units: 1.0,
                        code: "31000093",
                        errorMessages: [],
                        sequence_number: 0,
                        evidence: [],
                        additionalProperties: {
                            id: 18
                        }
                    },
                    procedure: {
                        procedure_code: "88173",
                        units: 1.0,
                        sequence_number: 1,
                        custom_cpt: true,
                        evidence: [],
                        errorMessages: [],
                        additionalProperties: {
                            id: 99
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "88173",
                        units: 1.0,
                        sequence_number: 1,
                        custom_cpt: true,
                        errorMessages: [],
                        evidence: [],
                        additionalProperties: {
                            id: 99
                        }
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "CAR.1",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 101
                            },
                            shared: false,
                            active: true
                        },
                        {
                            diagnosis_code: "CAR.0",
                            sequence_number: 2,
                            evidence: [],
                            additionalProperties: {
                                id: 102
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "R91.8",
                            sequence_number: 3,
                            evidence: [],
                            additionalProperties: {
                                id: 104
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "LIN.5",
                            sequence_number: 4,
                            evidence: [],
                            additionalProperties: {
                                id: 107
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "CAR.10",
                            sequence_number: 5,
                            evidence: [],
                            additionalProperties: {
                                id: 106
                            },
                            shared: false,
                            active: true
                        }
                    ],
                    fee_schedule: "5000356",
                    place_of_service: "BWH_LNWTHYND"
                },
                {
                    guid: "937389a9-dbb6-48b8-bd93-b7992f4add5f",
                    sequence_number: 2,
                    source_transaction_id: "1",
                    deleted: false,
                    errorMessages: [],
                    technical_code: {
                        errorMessages: [],
                        units: 2.0,
                        code: "31000065",
                        sequence_number: 0,
                        evidence: [],
                        additionalProperties: {
                            id: 19
                        }
                    },
                    procedure: {
                        procedure_code: "31000065",
                        units: 2.0,
                        sequence_number: 1,
                        custom_cpt: false,
                        evidence: [],
                        errorMessages: [],
                        additionalProperties: {
                            id: 100
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "88104",
                        units: 2.0,
                        sequence_number: 1,
                        errorMessages: [],
                        custom_cpt: true,
                        evidence: [],
                        additionalProperties: {
                            id: 101
                        }
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "CAR.0",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 103
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "R91.8",
                            sequence_number: 2,
                            evidence: [],
                            additionalProperties: {
                                id: 105
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "LIN.5",
                            sequence_number: 3,
                            evidence: [],
                            additionalProperties: {
                                id: 108
                            },
                            shared: true,
                            active: true
                        }
                    ],
                    fee_schedule: "5000356",
                    place_of_service: "BWH_LNWTHYND"
                }
            ],
            deleted: false,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        }
    ],
    errors: [],
    cancelled: false
};
//# sourceMappingURL=shared-codes.js.map